import React, { useState, useEffect } from 'react';
import { submitFeedback } from 'utils/methods/feedback';
import { useSelector } from 'react-redux';



const FeedbackForm = () => {
	const [open, setOpen] = useState(false);
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [feedback, setFeedback] = useState('');
	const [submitted, setSubmitted] = useState(false);
	const [error, setError] = useState(null);

	const user = useSelector(state => state.user.user);

	// When dialog opens, autopopulate name/email from user state
	useEffect(() => {
		if (open && user) {
			setName(user.full_name || '');
			setEmail(user.email || '');
		}
	}, [open, user]);

	const handleOpen = () => setOpen(true);
	const handleClose = () => {
		setOpen(false);
		setSubmitted(false);
		setName('');
		setEmail('');
		setFeedback('');
		setError(null);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError(null);
		try {
			await submitFeedback({
				name: name || 'Anonymous',
				email: email || '',
				message: feedback,
                additional_details: window.location.href
			});
			setSubmitted(true);
			setTimeout(() => {
				handleClose();
			}, 1500);
		} catch (err) {
			setError('Failed to submit feedback. Please try again.');
		}
	};

	return (
		<>
			{/* CTA Button */}
			<button
				onClick={handleOpen}
				className="fixed bottom-8 right-8 z-50 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full shadow-lg transition-all duration-300"
			>
				Give Feedback
			</button>

			{/* Dialog Box */}
			{open && (
				<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
					<div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md relative animate-fadeIn">
						<button
							onClick={handleClose}
							className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 text-2xl font-bold"
							aria-label="Close"
						>
							&times;
						</button>
						<h2 className="text-2xl font-bold mb-4 text-blue-700">We value your feedback!</h2>
						{submitted ? (
							<div className="text-green-600 text-center font-semibold py-8">Thank you for your feedback!</div>
						) : (
							<form onSubmit={handleSubmit} className="space-y-4">
								<div>
									<p className="text-gray-600 mb-4">Please let us know your thoughts or any issues you encountered on this page, we will review your feedback and make improvements.</p>
								</div>
								<div>
									<label className="block text-gray-700 font-semibold mb-1">Feedback <span className="text-red-500">*</span></label>
									<textarea
										value={feedback}
										onChange={e => setFeedback(e.target.value)}
										className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
										placeholder="Your feedback..."
										rows={4}
										required
									/>
								</div>
								{error && <div className="text-red-600 text-sm text-center">{error}</div>}
								<div className="flex justify-end gap-2 mt-6">
									<button
										type="button"
										onClick={handleClose}
										className="px-4 py-2 rounded-lg border border-gray-300 bg-gray-100 text-gray-700 hover:bg-gray-200"
									>
										Cancel
									</button>
									<button
										type="submit"
										className="px-6 py-2 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition-all"
									>
										Submit
									</button>
								</div>
							</form>
						)}
					</div>
				</div>
			)}
		</>
	);
};

export default FeedbackForm;
